import { Check } from "lucide-react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1400&q=85";

const BULLETS = [
  "Ethical sourcing across the Yiwu wholesale market",
  "Customs clearance in India, UK, Middle East & beyond",
  "Factory audits, verified suppliers, full translation",
  "One point of contact — from quote to delivery",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-white py-14 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left column — big number + narrative */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-signal mb-5">
              02 — About Emporia
            </p>
            <div className="flex items-start gap-6 md:gap-10">
              <div
                className="font-heading font-black text-ink-900 leading-[0.78] tracking-[-0.05em] text-[28vw] md:text-[180px]"
                aria-hidden
              >
                15
                <span className="text-signal">+</span>
              </div>
              <div className="pt-4 md:pt-8 max-w-md">
                <p className="text-ink-500 text-base md:text-lg leading-relaxed">
                  Years of commanding the Yiwu wholesale market. We orchestrate
                  door-to-door delivery, customs clearance and multilingual
                  sourcing — so you can focus on scale.
                </p>
              </div>
            </div>

            <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-2xl">
              {BULLETS.map((b, i) => (
                <div
                  key={i}
                  data-testid={`about-bullet-${i}`}
                  className="flex items-start gap-3 p-4 md:p-5 border border-ink-100 bg-ink-50"
                >
                  <span className="w-6 h-6 flex-shrink-0 bg-signal text-white flex items-center justify-center">
                    <Check className="w-3.5 h-3.5" strokeWidth={2.5} />
                  </span>
                  <p className="text-ink-800 text-sm md:text-[15px] leading-snug">
                    {b}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right column — image with accent */}
          <div className="lg:col-span-5 order-1 lg:order-2 relative">
            <div className="relative aspect-[4/5] w-full overflow-hidden bg-ink">
              <img
                src={ABOUT_IMG}
                alt="Modern architectural interior — turnkey project delivery"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/10 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/70">
                  Yiwu HQ  ·  On the ground since 2010
                </p>
                <p className="font-heading font-bold text-2xl md:text-3xl mt-2 tracking-tight">
                  Where global trade begins.
                </p>
              </div>
              <span className="absolute top-6 left-6 w-3 h-3 bg-signal" aria-hidden />
            </div>
            <div className="hidden md:block absolute -bottom-6 -left-6 w-24 h-24 border border-ink-900" aria-hidden />
          </div>
        </div>
      </div>
    </section>
  );
}
